import {COMPONENT_SCHEMA,EVENTS_SCHEMA} from "../../../utils/configuration/schema";
import {getTextDefaultValue,getStyleDefaultValue,getLayoutDefaultValue} from '../../../utils/configuration/defaultSchema/schema.util'

export const fileUploadDefaultSchema = (data) => {
    const {componentName,componentId,isPage} = data; return {
        component: {
            [COMPONENT_SCHEMA.ID]: `${componentName}${componentId !== '' ? '_' : ''}${componentId}`,
            [COMPONENT_SCHEMA.COMPONENT_NAME]: `${componentName}`,
            [COMPONENT_SCHEMA.SOURCE]: '',
            [COMPONENT_SCHEMA.PLACEHOLDER]: 'Placeholder',
            [COMPONENT_SCHEMA.ENABLED]: true,
            [COMPONENT_SCHEMA.UPLOAD_OPTIONS]: "Default"
        },
        text: getTextDefaultValue(data),
        style: getStyleDefaultValue(data),
        layout: getLayoutDefaultValue(data),
        events: [
            EVENTS_SCHEMA.CHANGE,
        ],
        exposeVariableDSIndex: 1
    }
}